// Types
// Components
import type React from 'react';
import HistoryTime from 'components/HistoryTime';
import _ from 'lodash';
import type { TDynamicAvailability } from '@timeedit/types/lib/types';
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';
// Utils
import intl from '../../../../i18n/intl';

const language: any = intl.messages;

interface Props {
  dynamicAvailability?: TDynamicAvailability;
  onChange: (updatedValues: Record<string, any>) => void;
}

const GeneralInfo: React.FC<Props> = ({ dynamicAvailability, onChange }) => {
  return (
    <TEDrawerSection label="General info">
      <div className="section-col">
        <TEInput.PureText
          label="Type"
          tooltip="Type"
          value={language[dynamicAvailability?.dynamicAvailabilityType || '']}
          data-testid="type"
        />
        <TEInput.Input
          label="Name"
          tooltip="Name"
          placeholder="New dynamic availability"
          value={dynamicAvailability?.name}
          onChange={(val) => onChange({ name: val })}
          data-testid="dynamic-name"
        />
        <TEInput.TextArea
          label="Description"
          tooltip="Description"
          value={dynamicAvailability?.description}
          onChange={(val) => onChange({ description: val })}
          data-testid="description"
        />
        <HistoryTime history={dynamicAvailability?.history} />
      </div>
    </TEDrawerSection>
  );
};

export default GeneralInfo;
